import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-user",
  "use": "icon-user-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-user\"><path d=\"M642.482 482.726c84.946-44.995 131.595-128.916 131.595-225.918C774.156 115.205 656.508 0 511.911 0 367.235 0 249.587 115.205 249.587 256.808c0 97.08 42.552 180.923 127.498 225.918-192.98 54.056-336.868 241.442-336.868 450.655 0 43.418 3.073 89.673 97.711 90.383 84.473.63 573.74-.237 748.28 0 77.46.078 97.16-45.074 97.555-90.383 2.048-207.322-147.986-396.599-341.281-450.655z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol